<!--zx_rts_db.t_rt_cars（车辆表）-table-->
<!--参数添加，1、config.js business中添加：cars: '后台地址'-->
<!--参数添加，2、global.js businessFlag中添加：cars: 'cars'-->
<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 2">
      <el-breadcrumb separator=":">
        <el-breadcrumb-item>当前位置</el-breadcrumb-item>
        <el-breadcrumb-item>车辆列表</el-breadcrumb-item>
      </el-breadcrumb>
      <!--查询区域-->
      <el-row class="margin-top-10">
        <el-col :span="2" class="margin-top-10">
          <label class="search-label">
            区域:
          </label>
        </el-col>
        <el-col :span="4" class="margin-top-10">
          <cascader :set-props="setProps"
                    :set-size="GLOBAL.config.systemSize" maxlength="64"
                    ref="myArea">
          </cascader>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <label class="search-label">
            人员姓名:
          </label>
        </el-col>
        <el-col :span="4" class="margin-top-10">
          <el-input v-model="searchForm.xm"
                    :size="GLOBAL.config.systemSize"
                    placeholder="人员姓名"
                    clearable
                    maxlength="32"></el-input>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <label class="search-label">
            车牌号:
          </label>
        </el-col>
        <el-col :span="4" class="margin-top-10">
          <el-input v-model="searchForm.cph"
                    :size="GLOBAL.config.systemSize"
                    placeholder="车牌号"
                    clearable
                    maxlength="32"></el-input>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
          </el-button>
        </el-col>
        <el-col :span="2" class="margin-top-10">
          <el-button type="primary" @click="exportFile" :size="GLOBAL.config.systemSize" icon="el-icon-download">导出
          </el-button>
        </el-col>
      </el-row>
      <el-row class="margin-top-20">
        <el-col :span="24">
          <el-button v-if="source.add"
                     type="primary"
                     icon="el-icon-plus"
                     :size="GLOBAL.config.systemSize"
                     style="float: left;"
                     @click="operationMethod('addCarInfo')">新增
          </el-button>
          <el-button v-if="source.deleteBatch"
                     type="danger"
                     icon="el-icon-delete"
                     :size="GLOBAL.config.systemSize"
                     style="float: left;"
                     :disabled="deleteBatchList.ids.length === 0"
                     @click="deleteBatch">批量删除
          </el-button>
<!--          <el-button v-if="source.export"-->
<!--                     type="primary"-->
<!--                     icon="el-icon-upload2"-->
<!--                     :size="GLOBAL.config.systemSize"-->
<!--                     style="float: left;"-->
<!--                     @click="exportTableData">导出-->
<!--          </el-button>-->
<!--          <el-button v-if="source.import"-->
<!--                     type="primary"-->
<!--                     icon="el-icon-download"-->
<!--                     :size="GLOBAL.config.systemSize"-->
<!--                     style="float: left;"-->
<!--                     @click="importTableData">导入-->
<!--          </el-button>-->
        </el-col>
      </el-row>
      <el-table style="width: 100%"
                :data="tableData"
                @selection-change="tableSelectionChange"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading">
        <el-table-column
          type="selection">
        </el-table-column>
        <!--序号-->
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <!--当值司机-->
        <el-table-column prop="xm" label="人员姓名" align="center"/>
        <!--所属乡镇编码-->
        <el-table-column prop="ssxzmc" label="所属区域" align="center"/>
        <!--手机号-->
        <el-table-column prop="sjh" label="手机号" align="center"/>
        <!--车牌号-->
        <el-table-column prop="cph" label="车牌号" align="center"/>

        <!--更新时间-->
        <el-table-column prop="gxsj" label="更新时间" :formatter="formatterTime"/>
        <el-table-column prop="scope" label="操作" align="center">
          <template slot-scope="scope">
            <el-dropdown>
                <span class="el-dropdown-link operator-text">
                  选择操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :icon="item.icon" v-for="item in getSource(scope.row)"
                                  :key="item.method"
                                  @click.native="handleCommon(item.method, scope.row)">
                  {{item.title}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="margin-top-10 margin-bottom-20"
        @size-change="tableSizeChange"
        @current-change="currentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :layout="pagination.layout"
        :total="pagination.total">
      </el-pagination>
      <!--操作-->
      <careditor ref="careditor" :refresh="init"/>
      <!--    <operationTemplate ref="operationTemplate" :refresh="getTableData"/>-->
      <!--查看-->
      <el-dialog
        :fullscreen="true"
        :show-close="false"
        :visible.sync="viewVisibleFlag"
        :destroy-on-close="true"
      >
        <operationEdit
          ref="operationEdit"
          :refresh="init"
          :close-self="()=> viewVisibleFlag = false"
        />
      </el-dialog>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
    // 替换成相应的模板
    // import operationTemplate from './CarsOperateDialog'
    import operationEdit from './CarsInfo'
    import cascader from '../../components/Cascader'
    import careditor from './CarEditor'

    export default {
        name: 'CarsTable',
        data () {
            return {
                // 查询表单
                searchForm: {
                    cph: '',
                    ssxzbm: '',
                    xm: ''
                },
                // 所属区域
                setProps: {
                    multiple: false, // 单选
                    checkStrictly: true, // 父节点取消选中关联
                    value: 'code',
                    label: 'name',
                    children: 'childrens',
                    leaf: 'leaf'
                },
                tableData: [],
                // 字典数据
                dictionary: {},
                // 资源权限控制，有的系统不需这么细，则全部为true
                source: {
                    add: true,
                    deleteBatch: true,
                    export: true,
                    import: true,
                    infoView: true,
                    infoEdit: true,
                    infoDelete: true,
                    infoEditData: true
                },
                // 分页参数
                pagination: {
                    pageSizeList: [10, 20, 30, 40, 50],
                    pageSize: 10,
                    layout: 'total, sizes, prev, pager, next, jumper',
                    total: 0,
                    currentPage: 1
                },
                operationVisibleFlag: false,
                deleteBatchList: {
                    ids: [],
                    deleteFlag: false
                },
                loading: false,
                viewVisibleFlag: false
            }
        },
        components: {
            // operationTemplate,
            operationEdit,
            cascader,
            careditor
        },
        mounted () {
           this.init()
        },
        methods: {
            init: function () {
                this.getTableData('init')
            },
            doSearch: function () {
                this.getTableData('init')
            },
          // 新增车辆
            operationMethod: function (addCarInfo, info) {
              this.$refs.careditor.open(addCarInfo, info)
              //   this.$refs.operationTemplate.open(operateType, info)
            },
            deleteBatch: function () {
                let _this = this
                _this.$confirm('确认删除当前选择' +
                    '的' + _this.deleteBatchList.ids.length + '条数据？？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.loading = true
                    let params = {
                        type: 'deletePhysical',
                        baseService: 'TGcClServiceImpl',
                        infos: _this.deleteBatchList.ids
                    }
                    _this.FUNCTIONS.systemFunction.jsonPost(
                        _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                        params,
                        resultData => {
                            _this.loading = false
                            if (resultData.code === '200') {
                                _this.$message.success('删除成功～')
                                _this.deleteBatchList.ids = []
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning('删除失败～')
                            }
                        }
                    )
                })
            },
          // 获取操作展示
            getSource: function (rowData) {
                let tempList = []
                // this.source.infoView && tempList.push({icon: 'el-icon-view', title: '查看', method: 'handleView'})
                this.source.infoEdit && tempList.push({icon: 'el-icon-edit', title: '绑定人员', method: 'handleEdit'})
                this.source.infoEditData && tempList.push({icon: 'el-icon-edit', title: '编辑', method: 'handleEditData'})
                this.source.infoDelete && tempList.push({icon: 'el-icon-delete', title: '删除', method: 'handleDelete'})
                return tempList
            },
            handleCommon: function (type, rowData) {
                switch (type) {
                    case 'handleView':
                        this.handleView(rowData)
                        break
                    case 'handleEdit':
                        this.handleEdit(rowData)
                        break
                    case 'handleDelete':
                        this.handleDelete(rowData)
                        break
                    case 'handleEditData':
                        this.handleEditData(rowData)
                        break
                }
            },
            // 编辑车辆
            handleEditData: function(rowData) {
              this.$refs.careditor.open('editCarInfo', rowData)
            },
            // 查看
            handleView: function (rowData) {
                console.log(this.$router)
                this.$router.push({
                    name: 'CarsLaborInfo',
                    params: {
                        type: 'view',
                        carInfo: rowData
                    }
                })
            },
            // 编辑
            handleEdit: function (rowData) {
                this.$router.push({
                    name: 'CarsLaborDialog',
                    params: {
                        type: 'edit',
                        carInfo: rowData
                    }
                })
            },
            // 单条数据删除
            handleDelete: function (rowData) {
                let _this = this
                _this.$confirm('确认删除当前数据？？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        type: 'deletePhysical',
                        baseService: 'TGcClServiceImpl',
                        infos: [rowData.uuid]
                    }
                    _this.loading = true
                    _this.FUNCTIONS.systemFunction.jsonPost(
                        _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                        params,
                        resultData => {
                            _this.loading = false
                            if (resultData.code === '200') {
                                _this.$message.success('删除成功～')
                                _this.getTableData('init')
                            } else {
                                _this.$message.warning('删除失败～')
                            }
                        }
                    )
                })
            },
            // 获取列表
            getTableData: function (initPageFlag) {
                this.loading = true
                // 参数处理
                this.searchForm.ssxzbm = this.$refs.myArea.sendToParent('value')
                let _this = this, searchParams = this.searchForm
                _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
                let paginationData = _this.FUNCTIONS.systemFunction.paginationSet(
                    initPageFlag ? 1 : _this.pagination.currentPage,
                    initPageFlag ? 10 : _this.pagination.pageSize,
                    searchParams)
                let params = {
                    type: 'getListPage',
                    baseService: 'TGcClServiceImpl',
                    info: paginationData
                }
                // 3、 调接口获取数据
                _this.FUNCTIONS.systemFunction.jsonPost(
                    _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
                    params,
                    resultData => {
                        _this.loading = false
                        if (resultData.code === '200') {
                            // 结果参数赋值
                            _this.pagination.pageSize = resultData.obj.size
                            _this.pagination.total = resultData.obj.total
                            _this.pagination.currentPage = resultData.obj.current
                            // resultData.records.forEach(item => {
                            //     item.orgName = _this.FUNCTIONS.systemFunction.getAreaName(_this, item.villageCode)
                            // })
                            _this.tableData = resultData.obj.records
                        } else {
                            _this.$message.warning('获取列表数据失败～')
                        }
                    },
                    () => {
                        _this.loading = false
                    }
                )
            },
            // 分页方法
            tableSizeChange: function (pageSize) {
                this.pagination.pageSize = pageSize
                this.getTableData()
            },
            currentChange: function (current) {
                this.pagination.currentPage = current
                this.getTableData()
            },
            // 复选框选择事件
            tableSelectionChange: function (targetList) {
                let ids = []
                targetList.forEach(item => {
                    ids.push(item.uuid)
                })
                this.deleteBatchList.ids = ids
                if (this.deleteBatchList.ids &&
                    this.deleteBatchList.ids.length > 0) {
                    this.deleteBatchList.deleteFlag = true
                } else {
                    this.deleteBatchList.deleteFlag = false
                }
            },
            formatterTime(row, column, data) {
                if (!data) {
                    return "";
                }
                var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                return data.replace(reg, "$1-$2-$3 $4:$5:$6");
            },
          exportFile: function () {
            let code = this.$refs.myArea.sendToParent('value')
            if (code) {
              this.searchForm.ssqh = code
            } else {
              this.searchForm.ssqh = ''
            }
            let param = this.FUNCTIONS.systemFunction.removeNullFields(this.searchForm)
            let paramsStr = '?'
            let paramsArr = []
            for (let key in param) {
              paramsArr.push(key + '=' + param[key])
              // paramsStr = paramsStr + key + '=' + param[key] + '&'
            }
            paramsStr = paramsStr + paramsArr.join('&')
            if (paramsStr === '?') {
              paramsStr = ''
            }
            window.location.href = this.CONFIG.urls.root + '/indexCommon/exportTGcCl' + paramsStr
          }
        },
        watch: {
            $route(to, form) {
                let _this = this
                setTimeout(function () {
                    _this.getTableData()
                }, 100)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/view/setFunction/CarsTable.vue